const promoBannerPlayVideoListener = () => {
    // const promoVideoElements = document.querySelectorAll('.js-promo-banner-video');
    const promoVideoPlayElements = document.querySelectorAll('.js-promo-banner-start-video');

    promoVideoPlayElements.forEach((el) => {
        el.addEventListener('click', () => {
            const videoElement = document.querySelector(
                `.js-promo-banner-video[data-video-id="${el.dataset.videoId || ''}"]`
            );

            if (videoElement) {
                videoElement.play();
            }
        });
    });
};

promoBannerPlayVideoListener();
